import { render, staticRenderFns } from "./ProductsVariationForm.vue?vue&type=template&id=55aa6a40&"
import script from "./ProductsVariationForm.vue?vue&type=script&lang=js&"
export * from "./ProductsVariationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports